import { Updatable } from "../Entity";

export default class ClickIdentifiers extends Updatable {
    constructor(clickIds?: Partial<ClickIdentifiers>) {
        super();
        if (clickIds) this.update(clickIds);
    }

    gclid: string;
    fbclid: string;
    msclkid: string;
    ttclid: string;

    get isEmpty() {
        return !this.gclid && !this.fbclid && !this.msclkid && !this.ttclid;
    }

    update(clickIds: Partial<ClickIdentifiers>, allowUndefined = false) {
        super.update(clickIds, allowUndefined);
    }

    toJson() {
        return {
            gclid: this.gclid,
            fbclid: this.fbclid,
            msclkid: this.msclkid,
            ttclid: this.ttclid,
        }
    }

    static fromJson(json: any) {
        return new ClickIdentifiers({
            gclid: json.gclid,
            fbclid: json.fbclid,
            msclkid: json.msclkid,
            ttclid: json.ttclid,
        })
    }
}
